import React from 'react';
import classNames from 'classnames';
import Lottie from 'lottie-react';

import { PaddingContainer, WidthContainer } from '@components';
import conceptAnimation from '@images/animations/conceptAnimation.json';

import * as styles from './Concept.module.scss';

export const Concept: React.FC = () => {
	return (
		<PaddingContainer className="gray-bg z-9 relative">
			<WidthContainer
				className={classNames(
					styles.root,
					'd-flex flex-column justify-content-between flex-md-row'
				)}
			>
				<div className={styles.typographies}>
					<p className="font-size-small-title mb-3 font-600">
						From concept to the final product.
					</p>
					<p className="mb-4 font-18">
						The foundations for successful development are already laid in a
						software architecture design. Together with your vision, we can
						create the perfect solution.
					</p>
					<p className="font-18">
						By choosing us, you may be sure that you will be provided with the
						best system design services created by the team of experienced
						designers. Our offer includes drawing up functional documentation as
						well as developing conceptual schemas and mockups.
					</p>
				</div>
				<div
					className={classNames(
						styles.animationContainer,
						'd-flex justify-content-center align-items-center'
					)}
				>
					<Lottie
						className={styles.animation}
						animationData={conceptAnimation}
						loop={true}
					/>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
